import {GenexLMSModel} from "@/models/lms/GenexLMSModel";
import Course from "@/models/lms/Course";
import GenexHelperMixins from "@/mixins/GenexHelperMixins";
import {API_V4_URL} from "@/Variables";
import Role from "@/models/lms/Role";
import RoleUser from "@/models/lms/RoleUser";

export default class User extends GenexLMSModel {
    static entity = 'users'
    static RoleUser;

    static fields() {
        return {
            id: this.attr(null),
            first_name: this.attr(null),
            last_name: this.attr(null),
            full_name: this.attr(null),
            email: this.attr(null),
            profile_image: this.attr(null),
            recent_courses: this.hasManyBy(Course, 'course_ids'),
            course_ids: this.attr(null),
            roles: this.belongsToMany(Role, RoleUser, "user_id", "role_id"),
        }
    }

    /**
     * Returns a user by its id
     * @function
     * @param {Array.<string>} [relationships=[]] - Relationships to bring along
     * @returns {Promise<Response>}
     */

    static FetchCurrent(relationships = []) {
        return this.api().get(`/users/me`, {
                ...GenexHelperMixins.methods.DefaultLMSHeadersAndBaseUrl(),
                params: {
                    with: relationships
                },
                dataTransformer: ({data: {data}}) => {
                    return GenexHelperMixins.methods.NormalizeRecursive(data);
                },
            }
        )
    }

    static showGroupUsers(group_id, page = 1, limit = 999) {
        return this.api().get(`/groups/${group_id}/users`, {
                ...GenexHelperMixins.methods.DefaultLMSHeadersAndBaseUrl(),
            params: {
                page: page,
                limit: limit

            },
            dataTransformer: (response) => {
                let storageArray = []
                response.data.data.forEach(element => {
                    let target = element
                    Object.assign(target, target.attributes)
                    element.id = parseInt(element.id)
                    storageArray.push(target)
                })

                return storageArray
            }
        })
    }

    /**
     *
     * @param user_id
     * @returns {*}
     * @constructor
     */
    static LoginIntoSIS(user_id) {
        return this.api().post(`/users/${user_id}/sis-passwordless-auth`, null, {
                ...GenexHelperMixins.methods.DefaultLMSHeadersAndBaseUrl(),
            save: false
        })
    }

    static GetUser(withUUID = false) {
        return this.api().get(API_V4_URL + 'users/me?with[]=roles&with[]=roles.permissions' + (withUUID ? '&with[]=uuid' : ''), {
            ...GenexHelperMixins.methods.DefaultLMSHeadersAndBaseUrl(),
            save: false
        })
    }


}
